import { changeLocale } from '../../libs/state';
import Context from '../../provider';
import React, { useContext, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import './index.scss';

export default function ToggleGroupComponent(props) {
  const {
    defaultValue,
    groupList,
    fullWidth = true,
    isChange=true,
    onChange
  } = props;

  const { dispatch, lang, me, isMobile } = useContext(Context);

  const [alignment, setAlignment] = useState(defaultValue);

  const handleAlignment = async (event, newAlignment) => {
    setAlignment(newAlignment);
    if (isChange) {
      await changeLocale({
        lang: newAlignment,
        timezone: me?.preferences?.timezone,
        dispatch: dispatch,
        updateRemote: !!me
      });
    }
    onChange && onChange(newAlignment);
  };

  return (
    <ToggleButtonGroup
      className={`${ isMobile ? 'mobile' : 'web'}-toggle-group`}
      value={isChange? lang : alignment}
      className={`${ isMobile ? 'mobile' : 'web'}-toggle-group`}
      exclusive
      fullWidth={fullWidth}
      onChange={handleAlignment}
      aria-label="text alignment"
    >
      {
        groupList.map((item) => (
          <ToggleButton key={item.value} value={item.value} aria-label={item.value}>
            {item.label}
          </ToggleButton>
        ))
      }
    </ToggleButtonGroup>
  );
}